"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_routerfi__hi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f1a332ba-9a6b-499b-9f9b-64f2a72310e9",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "router-hifi-hi"), /*#__PURE__*/React.createElement("path", {
    d: "M128.06,120.75a4,4,0,0,1-4-4V62a4,4,0,0,1,8,0v54.75A4,4,0,0,1,128.06,120.75Z",
    transform: "translate(0 -0.02)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.51,116h127A12.76,12.76,0,0,1,172,129v26a12.76,12.76,0,0,1-12.5,13h-127A12.76,12.76,0,0,1,20,155V129A12.76,12.76,0,0,1,32.51,116Z",
    transform: "translate(0 -0.02)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.47,166h-127A12.75,12.75,0,0,1,20,153v2a12.75,12.75,0,0,0,12.5,13h127A12.75,12.75,0,0,0,172,155v-2A12.75,12.75,0,0,1,159.47,166Z",
    transform: "translate(0 -0.02)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "946c5dde-962b-4131-8ee5-3fb99c547ccf",
    "data-name": "77f18b41-157a-40ca-ab4d-ba994b0e9cf0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160,43.33a2,2,0,0,1-1.43-.59,43.33,43.33,0,0,0-61.2,0,2,2,0,0,1-2.86-2.87,47.37,47.37,0,0,1,66.92,0,2,2,0,0,1,0,2.86A2,2,0,0,1,160,43.33Z",
    transform: "translate(0 -0.02)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "5e3d4934-0d70-4a66-9e20-cc0772483175",
    "data-name": "cdbd5f61-fd0a-4e50-ba06-a76e9b6374d3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.54,54a2,2,0,0,1-.91-.22,1.92,1.92,0,0,1-.53-.38,25.52,25.52,0,0,0-36,0,2,2,0,0,1-2.86,0,2,2,0,0,1,0-2.87,29.57,29.57,0,0,1,41.74,0l.07.07.1.12A2,2,0,0,1,147.54,54Z",
    transform: "translate(0 -0.02)",
    fill: "#e60000"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38.01,
    cy: 142,
    r: 6,
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.01,
    cy: 142,
    r: 2,
    fill: "#d62b11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.01,
    cy: 142,
    r: 2,
    fill: "#d62b11"
  }));
}

var _default = ic_routerfi__hi;
exports.default = _default;